// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
// S-44-T — Relatório de contas da Comissão de Manutenção. Mapa extraído do PDF oficial.

const fieldMap = {
  '900_1_Text': { label: 'Endereço do Salão do Reino', section: 'Cabeçalho' },
  '900_2_Text': { label: 'Mês/Ano', section: 'Cabeçalho' },
  '901_3_S44BOM': { label: '(a) Saldo no início do mês [valor do campo (e) do mês anterior]', section: 'Resumo' },
  '901_20_S44TotalRec': { label: '(b) Total das entradas', section: 'Entradas' },
  '901_47_S44TotalEx': { label: '(c) Total das despesas', section: 'Despesas' },
  '901_48_S44SurDef': { label: '(d) Saldo positivo (negativo) [(b) − (c)]', section: 'Resumo' },
  '901_49_S44EOM': { label: '(e) Saldo no final do mês [coloque no campo (a) do próximo mês]', section: 'Resumo' },
  '900_50_Text': { label: 'Fundo reservado 1 — Descrição', section: 'Fundos Reservados' },
  '901_51_S44Spec': { label: 'Fundo reservado 1 — Valor', section: 'Fundos Reservados' },
  '900_52_Text': { label: 'Fundo reservado 2 — Descrição', section: 'Fundos Reservados' },
  '901_53_S44Spec': { label: 'Fundo reservado 2 — Valor', section: 'Fundos Reservados' },
  '901_54_S44TotalSpec': { label: '(f) Total dos fundos reservados', section: 'Fundos Reservados' },
  '901_55_S44TotalFunds': { label: '(g) Fundos disponíveis [(e) − (f)]', section: 'Resumo' },
};

// Entradas: 8 linhas (descrição 900_4..900_18, valor 901_5..901_19 — passo 2)
for (let n = 1; n <= 8; n++) {
  fieldMap[`900_${2 + 2 * n}_Text`] = { label: `Entrada ${n} — Descrição`, section: 'Entradas' };
  fieldMap[`901_${3 + 2 * n}_S44Rec`] = { label: `Entrada ${n} — Valor`, section: 'Entradas' };
}
// Despesas: 13 linhas (descrição 900_21..900_45, valor 901_22..901_46 — passo 2)
for (let n = 1; n <= 13; n++) {
  fieldMap[`900_${19 + 2 * n}_Text`] = { label: `Despesa ${n} — Descrição`, section: 'Despesas' };
  fieldMap[`901_${20 + 2 * n}_S44Ex`] = { label: `Despesa ${n} — Valor`, section: 'Despesas' };
}

const S44_SECTION_COLORS = {
  'Cabeçalho': 'bg-blue-500',
  'Entradas': 'bg-emerald-500',
  'Despesas': 'bg-amber-500',
  'Fundos Reservados': 'bg-purple-500',
  'Resumo': 'bg-rose-500',
};

export const S44_CONFIG = {
  formType: 's44',
  title: 'S-44',
  formLabel: 'S-44',
  fieldMap,
  sectionColors: S44_SECTION_COLORS,
  totalFields: Object.keys(fieldMap).length,
};
